import React from 'react';
import PromotionsForm from './PromotionsForm';

const CreatePromotion = ({ show, onHide }) => (
  <PromotionsForm show={show} onHide={onHide} mode="create" initialRow={null} />
);

export default CreatePromotion;
